export default __webpack_public_path__ + "static/media/Rain.d5efe9b0.png";